import React from "react";
import './section5.css';
import imagemSection5 from '../../assets/atracoes/Palestras-Atracoes4.svg'

const Section5 = () => {
  return (
    <section className="section5">        
      <img src={imagemSection5} alt="Descrição da Imagem" className="section5-image" />
    </section>
  );
};

export default Section5;
